import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  iconfont: "mdi",
  theme: {
    themes: {
      light: {
        primary: "#F79406",
        secondary: "#4caf50",
        tertiary: "#495057",
        accent: "#000000",
        error: "#f55a4e",
        info: "#00d3ee",
        success: "#5cb860",
        warning: "#ffa21a",
        general: "#2196F3",
        background: "#ffffff"
      },
      dark: {
        // TODO
        primary: "#F79406",
        secondary: "#b0bec5",
        accent: "#50c79b",
        anchor: "#8c9eff",
        background: "#111111"
      }
    }
  }
});

export default vuetify;
